<template>
  <div class="bottom">
    <input v-model.trim="msg" type="text" class="input" :placeholder="content.placeholder" />
    <div class="enter" @click="handleEnter">确定</div>
  </div>
</template>

<script lang="ts">
import { Content } from '@forchange/storytime';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const userModule = namespace('common');

@Component
export default class TextInputControl extends Vue {
  @Prop({ type: Object }) content!: Content & { placeholder: string };
  @userModule.State('loading') public globalLoading!: boolean;

  get portalView() {
    const portalSequence = this.$store.state.common.portalSequence;
    return portalSequence[portalSequence.length - 1];
  }

  msg = '';
  mounted() {
    this.onKeyboard();
  }

  private onKeyboard() {
    document.addEventListener('keyup', this.onKeyPress);
    this.$once('hook:beforeDestroy', () => {
      document.removeEventListener('keyup', this.onKeyPress);
    });
  }

  private onKeyPress(event: KeyboardEvent) {
    switch (event.code) {
      case 'Enter':
        this.handleEnter();
        break;
    }
  }

  handleEnter() {
    if (this.globalLoading) return;
    if (!this.msg)
      return this.$Message.info({
        time: 1500,
        content: '要先填写才能继续哦'
      });
    window.storyteller.input(this.msg);
    this.msg = '';
    if (this.portalView) return this.$store.commit('common/popPortal');
    window.next();
    this.$emit('next');
  }
}
</script>

<style scoped>
.bottom {
  @apply flex justify-center items-center 2xl:w-2/5 lg:w-3/5 md:w-4/5 w-full mx-auto px-3 py-2 h-16 cursor-pointer select-none bg-white;
}
.input {
  @apply flex-1 w-full h-full rounded-md border-0 ring-motif-500;
  background-color: rgba(240, 241, 246, 1);
}

.input::placeholder {
  color: rgba(136, 136, 136, 1);
}
.enter {
  @apply flex items-center justify-center ml-2 w-20 h-full cursor-pointer rounded-md text-white bg-motif hover:opacity-hover active:opacity-active;
  flex: 0 0 5rem;
}
</style>
